import { Pipe, PipeTransform } from '@angular/core';
import { ReportLogOfEvents } from '@report/models/report-of-event-log';
import {
  hoursAndMinutesStringToNumber,
  minutesToHoursAndMinutes,
} from '@shared/utils';

@Pipe({
  name: 'sumLogOfEvents',
})
export class SumLogOfEventsTimePipe implements PipeTransform {
  transform(
    value: ReportLogOfEvents,
    propertySum: string,
    isActivityGroup: boolean
  ): string {
    let sum = 0;
    value.reportOfEventLog.forEach((logOfEvents) => {
      if (isActivityGroup) {
        sum += hoursAndMinutesStringToNumber(logOfEvents[propertySum]);
      } else {
        logOfEvents.activities.forEach((activity) => {
          sum += hoursAndMinutesStringToNumber(activity[propertySum]);
        });
      }
    });

    return minutesToHoursAndMinutes(sum);
  }
}
